import { fetchLessonClassLearningGoals } from "classroom/api/teacher";
import type { MyLessonGroupLearningObjectivesResource } from "api/generated";
import { defineStore } from "pinia";

export const useClassroomLessonClassLearningGoalsStore = defineStore(
  "classroomLessonClassLearningGoals",
  () => {
    const loadLessonGroup = async (
      scheduleId: string,
      periodId: number,
      signal?: AbortSignal,
    ): Promise<MyLessonGroupLearningObjectivesResource> => {
      return fetchLessonClassLearningGoals(scheduleId, periodId, signal);
    };

    return { loadLessonGroup };
  },
);
